<template >
    <div class="container">

    <!-- Outer Row -->
    <div class="row justify-content-center">

      <div class="col-xl-10 col-lg-12 col-md-9">

        <div class="card o-hidden border-0 shadow-lg my-5">
          <div class="card-body p-0">
            <!-- Nested Row within Card Body -->
            <div class="row">
              <div class="col-lg-12">
                <div class="p-5">
                  <div class="text-center">
                    <h1 class="h4 text-gray-900 mb-4">Хичээл нэмэх</h1>
                  </div>
                  <form class="user">
                    <div class="form-group">
                      <label>Xичээлийн нэр</label>
                      <input v-model.trim="lesson.name" type="text" class="form-control" placeholder="Хичээлийн нэр">
                    </div>
                    <div class="form-group">
                      <label>Хичээлийн англи нэр</label>
                      <input v-model.trim="lesson.engName" type="text" class="form-control" placeholder="Хичээлийн англи нэр">
                    </div>
                    <div class="form-group">
                      <label>Дэлгэрэнгүй</label>
                      <textarea v-model.trim="lesson.description" type="text" class="form-control" placeholder="Дэлгэрэнгүй" rows="10"/>
                    </div>

                    <div class="row">
                       <div class="col form-group">
                         <label>Xичээлийн код</label>
                        <input v-model.trim="lesson.lectureCode" type="text" class="form-control"  placeholder="Xичээлийн код">
                       </div>
                       <div class="col form-group">
                         <label>Кредит</label>
                        <input v-model.number="lesson.credit" type="number" class="form-control"  placeholder="Кредит">
                      </div>
                    </div>
                    <div class="row">
                      <div class="col form-group">
                        <label >Өмнөх холбоос хичээл:</label>
                        <select class="form-control" v-model="lesson.precourese">
                          <option v-for="semester in rootlessons" v-bind:key="'semester-'+semester.id" v-bind:value="semester.ref">{{semester.name}} - {{semester.hindex}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col form-group">
                        <label>Лекцийн цаг</label>
                        <input v-model.number="lesson.hourForLecture" type="number" class="form-control"  placeholder="Лекцийн цаг">
                      </div>
                      <div class="col form-group">
                        <label>Семинарын цаг</label>
                        <input v-model.number="lesson.hourForSeminar" type="number" class="form-control"  placeholder="Семинарын цаг">
                      </div>
                    </div>


                    <hr/>
                    <div class="row">
                      <div class="text-center col">
                        <a class="small" href="#" @click="$router.back()">Буцах</a>
                      </div>
                      <div class="col">
                        <div @click="save" class="btn btn-primary">
                          Хадгалах
                        </div>
                      </div>
                    </div>
                    <hr>
                   
                  </form>
                  
                 
                
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
const fb = require('../../firebaseConfig.js')
export default {
    name: "RootLessonAdd",
    data() {
        return {
            lesson: {
                name: '',
                description: '',
                lectureCode:'',
                engName:"",
                hourForLecture:'',
                hourForSeminar:'',
                // skills:[],
                credit:null,
                precourese:null
               
            },
            performingRequest:false,
          
            schools:[],
            school:null,
            department:null,
            program:null,
            rootlessons:[]
           
        };
    },
    methods: {
        async save() {
            this.performingRequest = true;
            if(this.schoolId && this.departmentId){
              if(this.lesson!=null && this.lesson.name!='' && this.lesson.lectureCode){
                
                if(this.lesson.id && this.lesson.id!='' && this.lesson.id!='new'){
                  this.lesson.modifiedUser=fb.usersCollection.doc(this.$store.getters.currentUser.uid);
                  this.lesson.modifiedAt=new Date();
                  await fb.db.collection("schools/"+this.schoolId+"/rootlessons").doc(this.lesson.id).update(this.lesson);
                }
                else{  
                  this.lesson.userId=this.$store.getters.currentUser.uid;
                  this.lesson.user=fb.usersCollection.doc(this.$store.getters.currentUser.uid);
                  this.lesson.createdAt=new Date();
                  if(this.schoolId){
                    this.lesson.school=fb.db.collection("schools").doc(this.schoolId);
                    fb.db.collection("schools").doc(this.schoolId).update({
                      'numberOfRootLessons': fb.firestore.FieldValue.increment(1)
                    });
                    
                  }
                  if(this.schoolId!=null && this.departmentId!=null){
                    this.lesson.department=fb.db.collection("schools").doc(this.schoolId).collection("departments").doc(this.departmentId);
                    if(this.setDepartment==false){
                      fb.db.collection("schools").doc(this.schoolId).collection("departments").doc(this.departmentId).update({
                        'numberOfRootLessons': fb.firestore.FieldValue.increment(1)
                      });
                    }
                  }
                  await fb.db.collection("schools/"+this.schoolId+"/rootlessons").doc().set(this.lesson);
                }

                  
                  this.$router.back();
              }
              else{
                alert("Та хичээлийнхээ нэр,код оруулна уу");
              }
            }
        },
        setLesson(){
          this.lesson={
                name: '',
                description: '',
                lectureCode:'',
                engName:"",
                hourForLecture:'',
                hourForSeminar:'',
                // skills:[],
                credit:null,
                precourese:null

            }
        },
        remove(index, array){
          if(array!=null && array.length>0)
            array.splice(index, 1)
        },
        _getQA(){
          if(this.lessonId!=null && this.lessonId!=''){
            var docRef=fb.db.collection("schools/"+this.schoolId+"/rootlessons").doc(this.lessonId).get().then(doc=> {
                this.lesson=doc.data();
                this.lesson.id=doc.id;
     
            }).catch(function(error) {
                console.log("Error getting document:", error);
            });

          }
        },

         addType(type){
          if(this.lesson.types==null || this.lesson.types==undefined)
            this.lesson.types=[];
          if(!this.lesson.types.includes(type))
            this.lesson.types.push(type);
          else
            this.lesson.types.splice(this.lesson.types.indexOf(type), 1); 
        }
        
    }, 
    props: {
      lessonId: { 
        required: false,
      },
      schoolId:{
        required:true
      },
      departmentId:{
        required:true
      }
    },
    created() {
        var _this=this;
        fb.db.collection("schools").doc(this.schoolId).collection("rootlessons").get().then(docs=>{
          docs.docs.forEach(doc=>{
            if(doc.exists){
              let object=doc.data();
              object.id=doc.id;
              object.ref=doc.ref;
              this.rootlessons.push(object);
            }
          });
        });
        if(this.lessonId!=null && this.lessonId!='')
          this._getQA();
        
        
            
    },
  
};
</script>

